export function iteratorToObject<T>(iterator: IterableIterator<[string, T]>): Record<string, T> {
    const obj: Record<string, T> = {}
    for (const [key, value] of iterator) {
        obj[key] = value
    }
    return obj
}

export const ensureUrl = (str: string): string => {
    try {
        new URL(str)
        return str
    } catch (_) {
        return `https://${str}`
    }
}
